<template>
  <div class="logo-container">
    <div class="logo">
      <img :src="src" alt="logo" class="room-logo" @error="handleError" />
      <h3 class="semibold service-name">
        {{ title || qrTitle }}
      </h3>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useCallStore } from '@/stores/call';

const callStore = useCallStore();

withDefaults(
  defineProps<{
    title?: string;
  }>(),
  {
    title: '',
  }
);

const qrTitle = computed<string>(() => {
  const { title = '' } = callStore.qrCodeInfo || { title: '' };
  return title;
});

const src = computed<string>(() => {
  const { callLogoImageUrl = '' } = callStore.qrCodeInfo || {
    callLogoImageUrl: '',
  };
  return callLogoImageUrl;
});

const handleError = (e) => {
  e.target.src = 'https://sconchat.blob.core.windows.net/sconchat/partner/profile/image/2/logo/1755600635205739.jpg';
};
</script>

<style scoped lang="scss">
.logo-container {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  flex: 1;
  min-width: 0;
}

.room-logo {
  width: 3rem;
  height: 3rem;
  border-radius: 100px;
  outline: 1px solid var(--border-dim);
}

.expo-logo {
  height: 3rem;
}

.service-name {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: $font-size-h5;
}

@media (max-width: 768px) {
  .service-name {
    font-size: $font-size-p;
  }
}
</style>
